export type Visibility = 'public' | 'private' | 'discoverable';

export const VISIBILITY_VALUES: Visibility[] = ['public', 'private', 'discoverable'];

export function isVisibility(value: unknown): value is Visibility {
  return typeof value === 'string' && VISIBILITY_VALUES.includes(value as Visibility);
}

// Albums whose contents are gated behind a share token. Discoverable albums are
// listed publicly but their contents require a token; private albums are not
// listed at all and their contents require a token.
export function requiresShareToken(visibility: Visibility): boolean {
  return visibility === 'private' || visibility === 'discoverable';
}